<!--托运单-->
<template>
  <div>
    <div id="formHtml" style="padding:30px 30px;color:#000000">
      <div style="background:#1c1c1c;">
        <table cellspacing="1" cellpadding="0" width="100%" >

          <tr >
            <td colspan="16" ><h2>危险货物道路运输托运清单</h2></td>
          </tr>
          <tr >
            <td >托运单编号</td>
            <td    colspan="15" style="text-align:left;"><input type="text" class="longInput" v-model="form.consNo" :class="edit(form.consNo)" /></td>
          </tr>
          <tr >
            <td  rowspan="3" width="100">托运人</td>
            <td   colspan="4" >名称</td>
            <td   colspan="4"><input type="text" v-model="form.consName1" :class="edit(form.consName1)"/></td>
            <td   colspan="2" >地点</td>
            <td   colspan="5" ><input type="text" v-model="form.address1" :class="edit(form.address1)"  placeholder="       省市、市、区（县）"/></td>
          </tr>
          <tr >
            <td   colspan="4" >联系电话</td>
            <td   colspan="4"><input type="text" v-model="form.contact1" :class="edit(form.contact1)"/></td>
            <td   colspan="2" >详细地址</td>
            <td   colspan="5"><input type="text" v-model="form.detailAddr1" :class="edit(form.detailAddr1)"/></td>
          </tr>
          <tr >
            <td   colspan="4" >许可证号</td>
            <td   colspan="4"><input type="text" v-model="form.license1" :class="edit(form.license1)"/></td>
            <td   colspan="2" >应急电话</td>
            <td   colspan="5"><input type="text" v-model="form.emergencyTel1" :class="edit(form.emergencyTel1)"/></td>
          </tr>
          <tr >
            <td   rowspan="3">收货人</td>
            <td   colspan="4" >名称</td>
            <td   colspan="4"><input type="text" v-model="form.constName2" :class="edit(form.constName2)"/></td>
            <td   colspan="2" >地点</td>
            <td   colspan="5" ><input type="text" v-model="form.address2" :class="edit(form.address2)"  placeholder="       省市、市、区（县）"/></td>
          </tr>
          <tr >
            <td   colspan="4" >联系电话</td>
            <td   colspan="4"><input type="text" v-model="form.contact2" :class="edit(form.contact2)"/></td>
            <td   colspan="2" >详细地址</td>
            <td   colspan="5"><input type="text" v-model="form.detailAddr2" :class="edit(form.detailAddr2)"/></td>
          </tr>
          <tr >
            <td   colspan="4" >许可证号</td>
            <td   colspan="11"><input type="text" v-model="form.license2" :class="edit(form.license2)"/></td>
          </tr>
          <tr >
            <td  rowspan="3" >装货人</td>
            <td   colspan="4" >名称</td>
            <td   colspan="4"><input type="text" v-model="form.constName3" :class="edit(form.constName3)"/></td>
            <td   colspan="2" >地点</td>
            <td   colspan="5" ><input type="text" v-model="form.address3" :class="edit(form.address3)"  placeholder="       省市、市、区（县）"/></td>
          </tr>
          <tr >
            <td   colspan="4" >联系电话</td>
            <td   colspan="4"><input type="text" v-model="form.contact3" :class="edit(form.contact3)"/></td>
            <td   colspan="2" >详细地址</td>
            <td   colspan="5"><input type="text" v-model="form.detailAddr3" :class="edit(form.detailAddr3)"/></td>
          </tr>
          <tr >
            <td   colspan="4" >许可证号</td>
            <td   colspan="11"><input type="text" v-model="form.license3" :class="edit(form.license3)"/></td>
          </tr>
          <!--<tr >-->
            <!--<td  rowspan="3" >人</td>-->
            <!--<td   colspan="4" >名称</td>-->
            <!--<td   colspan="4"><input type="text" v-model="form.test" :class="edit(form.test)"/></td>-->
            <!--<td   colspan="2" >地点</td>-->
            <!--<td   colspan="5" ><input type="text" v-model="form.test" :class="edit(form.test)"  placeholder="       省市、市、区（县）"/></td>-->
          <!--</tr>-->
          <!--<tr >-->
            <!--<td   colspan="4" >联系电话</td>-->
            <!--<td   colspan="4"><input type="text" v-model="form.test" :class="edit(form.test)"/></td>-->
            <!--<td   colspan="2" >详细地址</td>-->
            <!--<td   colspan="5"><input type="text" v-model="form.test" :class="edit(form.test)"/></td>-->
          <!--</tr>-->
          <!--<tr >-->
            <!--<td   colspan="4" >许可证号</td>-->
            <!--<td   colspan="11"><input type="text" v-model="form.test" :class="edit(form.test)"/></td>-->
          <!--</tr>-->
          <tr >
            <td  >始发地</td>
            <td   colspan="8"><input type="text" v-model="form.beginAddr" :class="edit(form.beginAddr)"/></td>
            <td   colspan="2">目的地</td>
            <td   colspan="5"><input type="text" v-model="form.endAddr" :class="edit(form.endAddr)"/></td>
          </tr>
          <tr >
            <td  >起运日期</td>
            <td   colspan="8"><input type="text" v-model="form.startDate" :class="edit(form.startDate)"/></td>
            <td   colspan="2">到货日期</td>
            <td   colspan="5"><input type="text" v-model="form.endDate" :class="edit(form.endDate)"/></td>
          </tr>
          <tr >
            <td  :rowspan="form.list.length+1" >货物信息</td>
            <td   colspan="3" >联合国编号</td>
            <td   colspan="2" >危险货物名称</td>
            <td   colspan="2" >类<font  >/项别</font></td>
            <td   colspan="2" >包装类别</td>
            <td   colspan="2" >规格</td>
            <td >单位</td>
            <td >数量</td>
            <td   colspan="2" >批次</td>
          </tr>
          <tr v-for="obj in form.list">
            <td   colspan="3"><input type="text" v-model="obj.unNumber" :class="edit(obj.unNumber)"/></td>
            <td   colspan="2"><input type="text" v-model="obj.goodsName" :class="edit(obj.goodsName)"/></td>
            <td   colspan="2"><input type="text" v-model="obj.className" :class="edit(obj.className)"/></td>
            <td   colspan="2"><input type="text" v-model="obj.packageCategory" :class="edit(obj.packageCategory)"/></td>
            <td   colspan="2"><input type="text" v-model="obj.specification" :class="edit(obj.specification)"/></td>
            <td  ><input type="text" v-model="obj.unitName" :class="edit(obj.unitName)"/></td>
            <td  ><input type="text" v-model="obj.count" :class="edit(obj.count)"/></td>
            <td  colspan="2"><input type="text" v-model="obj.batchNo" :class="edit(obj.batchNo)"/></td>
          </tr>
          <tr >
            <td  colspan="3" >安全技术说明书</td>
            <td   colspan="7"><input type="text" v-model="form.safetyInstructions" :class="edit(form.safetyInstructions)"/></td>
            <td   colspan="2" >安全标签</td>
            <td   colspan="4"><input type="text" v-model="form.safetyLabel" :class="edit(form.safetyLabel)"/></td>
          </tr>
          <tr >
            <td  colspan="2" >备注</td>
            <td   colspan="8" ><input type="text" v-model="form.remark" :class="edit(form.remark)"/></td>
            <td   colspan="2" >油品鉴定报告</td>
            <td   colspan="4"><input type="text" v-model="form.oilReport" :class="edit(form.oilReport)"/></td>
          </tr>
          <tr >
            <td  colspan="2" >企业电子印章</td>
            <td   colspan="5"><input type="text" v-model="form.noteNumber" :class="edit(form.noteNumber)"/></td>
            <td   colspan="5" >托运单编号二维码</td>
            <td   colspan="4"><input type="text" v-model="form.qrcode" :class="edit(form.qrcode)"/></td>
          </tr>
          <tr >
            <td  colspan="2" >制单人</td>
            <td   colspan="3"><input type="text" v-model="form.fromUserName" :class="edit(form.fromUserName)"/></td>
            <td   colspan="2" >从业资格证</td>
            <td   colspan="5"><input type="text" v-model="form.certificates" :class="edit(form.certificates)"/></td>
            <td   colspan="3" v-text="form.formDate">制单日期</td>
            <td  ></td>
          </tr>
          <tr >
            <td  colspan="2" >关联油品协议</td>
            <td   colspan="14">
              <el-select v-model="form.formProtocolId" placeholder="请选择">
                <el-option
                        v-for="item in oilProtocolList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div  class="dialog-footer" style="margin-top:10px;text-align: center;">
      <el-button @click="closeDialog()"  size="small">取 消</el-button>
      <el-button  size="small" type="primary" v-if="!prop.preview" @click="create('form')">保存</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {addObj, getObj, putObj} from "../../../api/admin/sysFormConsignment/index";
import {enterpriseDetail} from "../../../api/admin/sysEnterprise/index";
import {oilProtocolList} from "../../../api/admin/common";
export default {
  name: 'oilRegisterForm',
  props:["formId", "prop"],
  data() {
    return {
      editStatus:true,
      oilProtocolList:[],
      form:{
          formId: null,
          entName: null,
          entId: null,
          inputTime: null,
          status: null,
          crtUserId: null,
          consNo: null,
          consName1: null,
          address1: null,
          contact1: null,
          detailAddr1: null,
          license1: null,
          emergencyTel1: null,
          constName2: null,
          address2: null,
          contact2: null,
          detailAddr2: null,
          license2: null,
          emergencyTel2: null,
          constName3: null,
          address3: null,
          contact3: null,
          detailAddr3: null,
          license3: null,
          emergencyTel3: null,
          constName4: null,
          address4: null,
          contact4: null,
          detailAddr4: null,
          license4: null,
          emergencyTel4: null,
          beginAddr: null,
          endAddr: null,
          startDate: null,
          endDate: null,
          safetyInstructions: null,
          safetyLabel: null,
          remark: null,
          oilReport: null,
          noteNumber: null,
          qrcode: null,
          fromUserName: null,
          certificates: null,
          formDate: null,
          formProtocolId: null,
          list:[{
              listId: null,
              formId: null,
              unNumber: null,
              goodsName: null,
              className: null,
              packageCategory: null,
              specification: null,
              unitName: null,
              count: null,
              batchNo: null,
          }]
      }
    }
  },
    created() {
        this.init();
    },
    computed: {
        ...mapGetters([
            'elements'
        ])
    },
    methods: {
      init: function () {
          if(this.formId){
              oilProtocolList({}).then(response=>{
                  this.oilProtocolList = response.map(x=>{
                      return {"value": x.form_id, "label":"油品采购意向书或协议"}
                  });
                  getObj(this.formId).then(response=>{
                      this.form=response;
                  })
              });

          }else {
              enterpriseDetail({}).then(response => {
                  this.form.entName = response.entName;
              });
          }
      },
      create() {
          this.editStatus = false;
          this.$nextTick(()=>{
              addObj(this.form).then((response) => {
                  this.$notify({
                      title: '成功',
                      message: '删除成功',
                      type: 'success',
                      duration: 2000
                  });
                  this.$emit("on-success");
              })
          })
      },
    edit:function(val){
      if(val && String.valueOf(val).length>0 || this.prop.preview){
        return "edit";
      }
      return "";
    },
    closeDialog(){
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
table td {background:#FFF;padding:0px 4px;height:40px;box-sizing:border-box;text-align:center;}
table td .checkbox{width:16px;height:16px;border:solid 1px #000;background:#FFF;position:relative;top:3px;}
table td input{ display:inline-block;background:url(./img/edit.png) 10px no-repeat;width:100%;height:100%;border:none;text-indent:0px;border:none;font-size:14px;outline:none;padding-left:10px;box-sizing: border-box;}
table td .shortInput{ width:60px;height:100%;border:none;}
table td .longInput{ width:290px;height:100%;border:none;}
.edit{background:transparent;text-align:left;}
</style>